import { create } from 'zustand';
import { Roster } from '@/api/dto/dto';
import {devtools} from "zustand/middleware";

export type RosterState = {
  currentRoster: Roster | null;
  setCurrentRoster: (val: Roster | null) => void;
  selectedRoster: Roster | null;
  setSelectedRoster: (val: Roster) => void;
  // Roster a care-journey/task page is operating on. Driven by the `r` search param via
  // useJourneyRoster and kept separate from `currentRoster` so viewing a task never disturbs
  // the facility picker's selection.
  taskRoster: Roster | null;
  setTaskRoster: (val: Roster | null) => void;
}

export const useRosterStore = create<RosterState>()(
  devtools(
    (set) => ({
      currentRoster: null,
      setCurrentRoster: (val: Roster | null) => set({currentRoster: val }),
      selectedRoster: null,
      setSelectedRoster: (val: Roster) => set({selectedRoster: val }),
      taskRoster: null,
      setTaskRoster: (val: Roster | null) => set({taskRoster: val }),
    }),
    { name: 'rosterStore', enabled: ['local', 'dev', 'qa'].includes(process.env.REACT_APP_ENV || 'prod')},
  ),
);

/**
 * Resolves the roster the current view should act on. Task/journey pages set `taskRoster`, so their
 * subtree (including components shared with the client profile, like the message thread drawer)
 * resolves to the journey's group; everywhere else this falls back to the facility picker's
 * `currentRoster`. `taskRoster` is cleared when the journey page unmounts, so the fallback never
 * serves a stale task roster.
 */
export const useActiveRoster = (): Roster | null =>
  useRosterStore((state) => state.taskRoster ?? state.currentRoster);
